import { SourceRandom } from './weapon-events.js';

// C_TFGasManager::Update: local, deterministic point layout driven by native
// spawn seeds. Points own their particle systems until native removal/expiry.
export class GasCloud {
    constructor() { this.points = new Map(); this.expired = new Set(); this.moving = true; this.time = null; }
    reconcile(component, origin, time) {
        const seen = new Set();
        for (const state of component.gasPoints) {
            const key = `${state.id}:${state.tick}`; seen.add(key);
            if (this.points.has(key) || this.expired.has(key)) continue;
            const random = new SourceRandom((state.tick + component.gasSeed + state.id) | 0);
            this.points.set(key, { ...state, key, position: [origin[0] + random.range(-25, 25), origin[1] + random.range(-25, 25), origin[2]], born: time });
            this.moving = true;
        }
        for (const key of this.points.keys()) if (!seen.has(key)) this.points.delete(key);
        for (const key of this.expired) if (!seen.has(key)) this.expired.delete(key);
        this.time ??= time;
    }
    step(time, trace, contents = () => 0) {
        if (!Number.isFinite(time)) return;
        const elapsed = Math.max(0, Math.min(250, time - (this.time ?? time))); this.time = time;
        for (const [key, point] of this.points)
            if (time > point.born + 5000 || (contents(point.position) & 48)) { this.points.delete(key); this.expired.add(key); }
        if (!this.moving || !elapsed || !this.points.size) return;
        const steps = Math.min(8, Math.ceil(elapsed / (1000 / 60))), dt = elapsed / steps / 1000;
        for (let step = 0; step < steps && this.moving; step++) {
            let moved = false, deferred = false;
            for (const point of this.points.values()) {
                const bottom = point.position.map((v, i) => v - (i === 2 ? 25 : 0));
                const end = bottom.map((v, i) => v - (i === 2 ? dt * 25 : 0));
                const hit = trace(bottom, end); deferred ||= !!hit.deferred;
                if (hit.fraction === 1) { point.position[2] -= dt * 125; moved = true; }
            }
            // Native separation deliberately updates points in insertion order.
            for (const point of this.points.values()) {
                const sum = [0, 0, 0]; let count = 0;
                for (const other of this.points.values()) {
                    if (other === point || Math.hypot(...other.position.map((v, i) => v - point.position[i])) >= 47.5) continue;
                    for (let i = 0; i < 3; i++) sum[i] += other.position[i] - point.position[i]; count++;
                }
                if (!count) continue;
                const length = Math.hypot(...sum); if (!length) continue;
                const end = point.position.map((v, i) => v - sum[i] / length * 10);
                const hit = trace(point.position, end); deferred ||= !!hit.deferred;
                if (hit.fraction === 1) { point.position.splice(0, 3, ...end); moved = true; }
            }
            this.moving = moved || deferred;
        }
    }
    specs(name, source, time) {
        return [...this.points.values()].filter(point => time <= point.born + 5000).map(point => ({
            key: `gas:${source}:${point.key}`, name, source, ownerKey: source, flags: 1, attachType: 2,
            automatic: true, startTime: point.born, position: point.position, offset: [0, 0, 0], controlPoints: [], movingOrigin: true,
        }));
    }
}
